import { Modal, ModalBody, ModalHead } from '@dixa/lib-shared-habla';

import { ConversationPreview } from 'components/conversation/conversationPreview';
import { createAppModal } from 'utils/modal';

import styles from './conversationPreviewModal.module.scss';

/** A modal that displays the `ConversationPreview`. */
export const ConversationPreviewModal = createAppModal(
  { type: 'app:conversationPreview' },
  ({ isOpen, modal, hide }): JSX.Element => {
    return (
      <Modal
        isOpen={isOpen}
        className={styles.root}
        onClose={hide}
        allowClickOutside
      >
        <ModalHead
          className={styles.head}
          title={`Conversation #${modal.arg.csid}`}
          onClose={hide}
        />

        <ModalBody className={styles.body}>
          {isOpen && (
            <ConversationPreview
              csid={modal.arg.csid}
              onNavigateToConversation={hide}
            />
          )}
        </ModalBody>
      </Modal>
    );
  },
);
